<template>
    <div>
        <v-autocomplete v-model="value" :items="hoRakenneElementit" item-value="uuid" :item-text="getElementtiText" label="Hallitusohjelman rakenne-elementti"/>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {

        props: {
            hallitusUuid: String,
            value: String,
            jsonApi: String
        },

        data: function() {
            return {
                hoRakenneElementit: [],
                hoRakenneElementtiTyypit: [],
                dataLoadFailed: false
            }
        },

        methods: {
            getElementtiText(elementti) {
                return elementti.nimi.fi + ' (' + this.getElementtiTyyppiNimi(elementti) + ')';
            },
            getElementtiTyyppiNimi(elementti) {
                let elementtiTyyppi = this.hoRakenneElementtiTyypit.find(tyyppi => tyyppi.uuid === elementti.elementtiTyyppiUuid);
                return elementtiTyyppi ? elementtiTyyppi.nimi.fi : '';
            },
            loadRakenneElementit() {
                axios
                    .get(this.jsonApi + '/hankeikkuna-government-timeline/data/hoRakenneElementit?hallitusUuid=' + this.hallitusUuid)
                    .then(response => this.hoRakenneElementit = response.data)
                    .catch(() => this.dataLoadFailed = true)
            },
            loadRakenneElementtiTyypit() {
                axios
                    .get(this.jsonApi + '/hankeikkuna-government-timeline/data/hoElementtiTyypit')
                    .then(response => this.hoRakenneElementtiTyypit = response.data)
                    .catch(() => this.dataLoadFailed = true)
            }
        },

        watch: {
            hallitusUuid: function() {
                this.loadRakenneElementit();
            },
            value: function(newValue) {
                this.$emit('input', newValue);
            }
        },

        mounted() {
            this.loadRakenneElementtiTyypit();
            this.loadRakenneElementit();
        }

    }

</script>